var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9922 2.00003C18.9922 1.17161 18.3206 0.500033 17.4922 0.500033L3.99215 0.500032C3.16373 0.500032 2.49215 1.1716 2.49215 2.00003C2.49215 2.82846 3.16373 3.50003 3.99215 3.50003H15.9922V15.5C15.9922 16.3285 16.6637 17 17.4922 17C18.3206 17 18.9922 16.3285 18.9922 15.5L18.9922 2.00003ZM3.06066 18.5528L18.5528 3.06069L16.4315 0.939372L0.93934 16.4315L3.06066 18.5528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointingArrow);
export default __webpack_public_path__ + "static/media/pointing-arrow.eefcabb23d1c8340b25b0c33dd83b9d8.svg";
export { ForwardRef as ReactComponent };